import { useRegister } from '../../Contexts/RegisterProvider';

export default function Voucher() {
  const {voucher} = useRegister();

  return (
    <div style={{ paddingBottom: 40}}>
      <div style={{paddingTop: 20, display: 'grid', textAlign: 'center'}}>
        <div>
          Parabéns!<br />
          Você concluiu a primeira parte do processo.<br />
          Anote as letras e números do CUPOM abaixo.<br />
          Baixe o aplicativo n2, clicando em Google Play ou App Store, conforme o sistema do seu celular.
          <br /><br />
          Use esse CUPOM para se cadastrar no Aplicativo n2.<br />
          Após se cadastrar no Aplicativo n2, clique no Passo 1 e agende sua 1a. videoconferência para avançar no processo de solicitação do seu crédito.
          <br /><br />
        </div>
        <div style={{textAlign: 'center', display: 'unset', padding: 20, borderWidth: 2, borderColor: 'lightgray', borderStyle: 'dashed', fontWeight: 700, fontSize: 30, justifySelf: 'center'}}>
          {voucher || 'carregando...'}
          <img alt='copy' onClick={() => navigator.clipboard.writeText(`${voucher}`)} src="https://convite.n2app.info/assets/images/copy.png" style={{marginLeft: 10, marginTop: -4, height: 25, width: 25, cursor: 'pointer'}} />
        </div>
        <img src="https://convite.n2app.info/assets/images/qrcode.png" alt="Baixe o aplicativo da n2 pela Google Play Store" style={{marginTop: 20, display: 'unset', justifySelf: 'center'}} />
        <div style={{paddingTop: 30}}>
          <a href="https://play.google.com/store/apps/details?id=info.n2app" target="_blank" rel="noreferrer">
            <img src="https://convite.n2app.info/assets/images/google_play_2.png" alt="Baixe o aplicativo da n2 pela Google Play Store" />
          </a>
          <a href="https://apps.apple.com/br/app/id1499731786" target="_blank" rel="noreferrer">
            <img style={{marginTop: 3}} src="https://convite.n2app.info/assets/images/app_store_2.jpg" alt="Baixe o aplicativo da n2 pela Apple Store" />
          </a>
        </div>
      </div>
    </div>
  );
}
